import { array, literal, object, type InferOutput } from 'valibot'
import type { Nullable } from '../../../../../../typescript'
import Unexpected from '../../../../../Exception/Unexpected.class'
import { Engine } from '../../../../engine/Engine.type'
import createSampleEntity from '../../../../entity/createSampleEntity'
import { EntityHeadingDeg } from '../../../../entity/EntityHeading/consts'
import { EntityHeadingSchema, type EntityHeading } from '../../../../entity/EntityHeading/EntityHeading.type'
import { EntityTypeIdSchema, type EntityTypeId } from '../../../../entity/EntityTypeId.enum'
import entityTypeMetaList from '../../../../entity/entityTypeMetaList.generated'
import findByIdOrThrow from '../../../../findByIdOrThrow'
import type { PlayerId } from '../../../../player/PlayerId'
import { randomId } from '../../../../util/rand'
import type { ActionLog } from '../../ActionLog.type'
import { ActionType } from '../ActionType'

export const RownipulatorAddRowActionSchema = object({
  type: literal(ActionType.Map.RownipulatorAddRow),
  etypeIds: array(EntityTypeIdSchema),
  heading: EntityHeadingSchema,
})

export type RownipulatorAddRowAction = InferOutput<typeof RownipulatorAddRowActionSchema>

export function createRownipulatorAddRowAction(etypeIds: Array<EntityTypeId>, heading: EntityHeading): RownipulatorAddRowAction {
  return {
    type: ActionType.Map.RownipulatorAddRow,
    etypeIds,
    heading,
  }
}

export async function handleRownipulatorAddRowAction(
  engine: Engine,
  action: RownipulatorAddRowAction,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  actionLog: ActionLog
): Promise<void> {
  const { etypeIds, heading } = action

  const { state } = engine
  const { ents, width, height, rng } = state

  const etms = etypeIds.map(entityTypeId => findByIdOrThrow(entityTypeMetaList, entityTypeId))

  const playerId : Nullable<PlayerId> = 0

  if (heading === EntityHeadingDeg.South) {
    const y = 0
    state.height += 1
    ents.forEach((ent) => {
      ent.y += 1
      ent.id = randomId(ents, rng)
    })
    for (let x = 0; x < width; x++) {
      for (const etm of etms) {
        const ent = createSampleEntity(etm.id, playerId, randomId(ents, rng))
        ent.x = x
        ent.y = y
        ents.push(ent)
      }
    }

  } else if (heading === EntityHeadingDeg.East) {
    const x = width
    state.width += 1
    for (let y = 0; y < height; y++) {
      for (const etm of etms) {
        const ent = createSampleEntity(etm.id, playerId, randomId(ents, rng))
        ent.x = x
        ent.y = y
        ents.push(ent)
      }
    }

  } else if (heading === EntityHeadingDeg.North) {
    const y = height
    state.height += 1
    for (let x = 0; x < width; x++) {
      for (const etm of etms) {
        const ent = createSampleEntity(etm.id, playerId, randomId(ents, rng))
        ent.x = x
        ent.y = y
        ents.push(ent)
      }
    }

  } else if (heading === EntityHeadingDeg.West) {
    const x = 0
    state.width += 1
    ents.forEach((ent) => {
      ent.x += 1
      ent.id = randomId(ents, rng)
    })
    for (let y = 0; y < height; y++) {
      for (const etm of etms) {
        const ent = createSampleEntity(etm.id, playerId, randomId(ents, rng))
        ent.x = x
        ent.y = y
        ents.push(ent)
      }
    }

  } else {
    throw new Unexpected('unknown heading')
  }
}
